module.exports = __webpack_public_path__ + "img/tema-3-27.d32e7d63.svg";